import { motion } from "framer-motion";
import { Reveal } from "@/components/Layout";

const MILESTONES = [
  {
    year: "1998",
    title: "The First Lesson",
    place: "Chicago, IL",
    body:
      "As a child on Chicago's South Side, Toriano learns to read dogs from his mother Tonia — the quiet mentor whose love for animals would shape the movement to come.",
    media: "https://images.unsplash.com/photo-1553882809-a4f57e59501d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxnZXJtYW4lMjBzaGVwaGVyZCUyMGRvZyUyMHBvcnRyYWl0JTIwZGFyayUyMGNpbmVtYXRpY3xlbnwwfHx8fDE3ODU4MTczNjV8MA&ixlib=rb-4.1.0&q=85",
    media_caption: "Chicago · Late 1990s",
  },
  {
    year: "2002",
    title: "Wolfkeeper Founded",
    place: "Chicago, IL",
    body:
      "Toriano opens the first Wolfkeeper training kennel — a one-room studio dedicated to reactive-dog rehabilitation using humane, energy-based methodology.",
    media: "https://images.unsplash.com/photo-1622507141724-8ead15590e3e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxnZXJtYW4lMjBzaGVwaGVyZCUyMGRvZyUyMHBvcnRyYWl0JTIwZGFyayUyMGNpbmVtYXRpY3xlbnwwfHx8fDE3ODU4MTczNjV8MA&ixlib=rb-4.1.0&q=85",
    media_caption: "The first Wolfkeeper studio",
  },
  {
    year: "2008",
    title: "Apprenticeship with Cesar Millan",
    place: "Santa Clarita, CA",
    body:
      "Selected personally by Cesar Millan for a multi-year mentorship at the Dog Psychology Center — the crucible where the Wolfkeeper method is refined.",
    media: "https://customer-assets-v7afamib.emergentagent.net/job_packleader-hub/artifacts/foyq47ym_CESAR%20and%20I.jpeg",
    media_caption: "With Cesar Millan at the Dog Psychology Center",
  },
  {
    year: "2012",
    title: "First Service Dogs for Veterans",
    place: "Aurora, CO",
    body:
      "Wolfkeeper places its first cohort of service dogs with returning veterans, planting the seed for what would become the Golden Wolf Foundation.",
    media: "https://images.unsplash.com/photo-1602241628512-459cdd3234fe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwzfHx0aGVyYXB5JTIwc2VydmljZSUyMGRvZyUyMGdvbGRlbiUyMHJldHJpZXZlciUyMHBvcnRyYWl0fGVufDB8fHx8MTc4NTgxNzM2NXww&ixlib=rb-4.1.0&q=85",
    media_caption: "The first veteran cohort · Aurora, CO",
  },
  {
    year: "2016",
    title: "Campus Expansion",
    place: "Denver, CO",
    body:
      "The Denver residence campus opens — a 22-acre training facility with faculty housing, on-site veterinary partners, and a film studio.",
    media: "https://images.unsplash.com/photo-1641667838410-b257ca266e38?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxjaW5lbWF0aWMlMjBkYXJrJTIwZm9yZXN0JTIwd29vZHMlMjBtaXN0fGVufDB8fHx8MTc4NTgxNzM2NXww&ixlib=rb-4.1.0&q=85",
    media_caption: "Denver residence campus grounds",
  },
  {
    year: "2020",
    title: "Golden Wolf Foundation Launched",
    place: "Global",
    body:
      "The nonprofit arm of Wolfkeeper is formalized to fund veteran service dogs, youth trainers, and community rescue programs at no cost to recipients.",
    media: "https://images.unsplash.com/photo-1599826023510-a98d08764aec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxiZWxnaWFuJTIwbWFsaW5vaXMlMjBkb2clMjB0cmFpbmluZyUyMGFjdGlvbnxlbnwwfHx8fDE3ODU4MTczNjV8MA&ixlib=rb-4.1.0&q=85",
    media_caption: "The Foundation charter · 2020",
  },
  {
    year: "2023",
    title: "Global Reach",
    place: "Lisbon · Nairobi · Singapore",
    body:
      "International Wolfkeeper trainers and ambassadors begin operating on six continents. Certification standards are formally published.",
    media: "https://images.unsplash.com/photo-1683536816438-564ce7de3161?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxwZXJzb24lMjB0cmFpbmluZyUyMHdvcmtpbmclMjBkb2clMjBvdXRkb29ycyUyMG5hdHVyZXxlbnwwfHx8fDE3ODU4MTczNjV8MA&ixlib=rb-4.1.0&q=85",
    media_caption: "International certification field lab",
  },
  {
    year: "2025",
    title: "Trailblazer Award · Humane Society of the U.S.",
    place: "Cesar's Forum, Las Vegas",
    body:
      "The Humane Society names Toriano \"The Wolfkeeper\" Sanzone its Trailblazer of the Year — the movement's highest honor. The dedication: to Tonia Sanzone, the mother who started it all.",
    media: "https://customer-assets-v7afamib.emergentagent.net/job_packleader-hub/artifacts/0f7iuk2g_Trailblazer.jpeg",
    media_caption: "Trailblazer Award Winner · Cesar's Forum, Las Vegas",
    highlight: true,
  },
  {
    year: "2026",
    title: "The Online University",
    place: "Global · This Season",
    body:
      "Wolfkeeper opens its doors to the world with a full digital curriculum, AI tutoring, and a global cohort of students — from puppy raisers to master trainers.",
    media: "https://images.unsplash.com/photo-1622507141724-8ead15590e3e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxnZXJtYW4lMjBzaGVwaGVyZCUyMGRvZyUyMHBvcnRyYWl0JTIwZGFyayUyMGNpbmVtYXRpY3xlbnwwfHx8fDE3ODU4MTczNjV8MA&ixlib=rb-4.1.0&q=85",
    media_caption: "The online cohort opens · 2026",
  },
];

export default function Timeline({ testid = "founder-timeline" }) {
  return (
    <div data-testid={testid} className="relative">
      <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-[color:var(--wk-gold)]/40 to-transparent md:-translate-x-1/2" />
      <div className="space-y-20 md:space-y-32">
        {MILESTONES.map((m, i) => {
          const leftSide = i % 2 === 0;
          return (
            <Reveal key={m.year} delay={0.05 * (i % 3)}>
              <div className="relative grid md:grid-cols-2 gap-8 md:gap-16 items-center">
                {/* Node dot */}
                <div className="absolute left-4 md:left-1/2 top-4 -translate-x-1/2 z-10">
                  <motion.div
                    initial={{ scale: 0 }}
                    whileInView={{ scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    className={`w-4 h-4 rounded-full ${m.highlight ? "bg-[color:var(--wk-gold)]" : "bg-[color:var(--wk-bone)]"} ring-4 ring-black`}
                  />
                  {m.highlight && (
                    <div className="absolute inset-0 w-4 h-4 rounded-full bg-[color:var(--wk-gold)] animate-ping opacity-40" />
                  )}
                </div>

                {/* Text side */}
                <div className={`pl-12 md:pl-0 ${leftSide ? "md:pr-16 md:text-right md:order-1" : "md:col-start-2 md:pl-16 md:order-2"}`}>
                  <div className="overline text-[color:var(--wk-gold)]">{m.year} · {m.place}</div>
                  <div
                    className={`mt-3 font-serif-display text-3xl md:text-4xl leading-tight`}
                    style={m.highlight ? { color: "var(--wk-gold)" } : undefined}
                  >
                    {m.title}
                  </div>
                  <p className="mt-4 text-[color:var(--wk-bone-dim)] leading-relaxed max-w-xl md:inline-block">
                    {m.body}
                  </p>
                </div>

                {/* Media side */}
                <div className={`pl-12 md:pl-0 ${leftSide ? "md:col-start-2 md:pl-16 md:order-2" : "md:pr-16 md:order-1"}`}>
                  <motion.div
                    initial={{ opacity: 0, scale: 0.95 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 1, ease: [0.19, 1, 0.22, 1] }}
                    className="relative overflow-hidden rounded-2xl aspect-[4/3] group card-lux"
                  >
                    <img
                      src={m.media}
                      alt={m.title}
                      className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1600ms] group-hover:scale-105"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 cinema-overlay" />
                    <div className="absolute bottom-3 left-4 right-4 flex justify-between items-end gap-3 text-xs">
                      <div className="overline text-[10px] text-[color:var(--wk-gold)]">{m.year}</div>
                      <div className="italic text-[color:var(--wk-bone-dim)] text-right">{m.media_caption}</div>
                    </div>
                    {m.highlight && (
                      <div className="absolute top-3 left-3 overline text-[10px] px-2 py-1 rounded-full bg-[color:var(--wk-gold)] text-black">
                        Trailblazer 2025
                      </div>
                    )}
                  </motion.div>
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  );
}
